import { Field, Widget } from '@kanda-libs/ks-component-ts';
import { Text } from '@kanda-libs/ks-design-library';

import ToggleOptionalField from 'components/ToggleOptionalField';
import { User } from 'lucide-react';

import { GENDER_OPTIONS, GENDER_VALIDATION, PROPS } from './constants';
import useApplyFormPersonalInformationFields from './useApplyFormPersonalInformationFields';
import useDateOfBirthValidation from './useDateOfBirthValidation';

import { YOUR_INFO_CLASS_NAMES } from '../constants';

const PersonalInformationFields: React.FunctionComponent = function () {
  const { hasMiddleName, hasMaidenName } =
    useApplyFormPersonalInformationFields();
  const { validation } = useDateOfBirthValidation();
  return (
    <>
      <div className={YOUR_INFO_CLASS_NAMES.titleWrapper}>
        <User size={20} />
        <Text {...PROPS.pageTitle} />
      </div>
      <div className="flex flex-col sm:flex-row gap-x-4">
        <Widget.CreditCustomerDetailsFirstName {...PROPS.firstName} />
        <Widget.CreditCustomerDetailsLastName
          {...PROPS.lastName}
          className="-mt-2 sm:mt-0"
        />
      </div>
      {(hasMiddleName || hasMaidenName) && (
        <div className="flex flex-row gap-x-3 sm:gap-x-4">
          <span className="w-1/2 text-12-18-em text-neutral-700 mb-2">
            {hasMiddleName ? 'Middle Name' : null}
          </span>
          <span className="w-1/2 text-12-18-em text-neutral-700 mb-2">
            {hasMaidenName ? 'Maiden Name' : null}
          </span>
        </div>
      )}
      <div className="flex flex-row gap-x-3 sm:gap-x-4 mb-3 sm:mb-4">
        <ToggleOptionalField
          fieldName="credit.customer_details.middle_name"
          buttonLabel="Middle Name"
          className="my-auto"
          initalValue=""
          initiallyVisible={false}
        >
          <Widget.CreditCustomerDetailsMiddleName {...PROPS.middleName} />
        </ToggleOptionalField>
        <ToggleOptionalField
          fieldName="credit.customer_details.maiden_name"
          buttonLabel="Maiden Name"
          className="my-auto"
          initalValue=""
          initiallyVisible={false}
        >
          <Widget.CreditCustomerDetailsMaidenName {...PROPS.maidenName} />
        </ToggleOptionalField>
      </div>
      <div className="flex flex-row gap-x-4 w-full">
        <Widget.CreditCustomerDetailsTitle {...PROPS.titleMobile} />
        <Field.Validator validation={GENDER_VALIDATION}>
          <Field.Select {...PROPS.gender} options={GENDER_OPTIONS} />
        </Field.Validator>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-2 xl:grid-cols-3 gap-x-3 sm:gap-x-4">
        <Widget.CreditCustomerDetailsDateOfBirth
          {...PROPS.birthday}
          validation={validation}
          className="col-span-2 sm:col-span-1 md:col-span-2 xl:col-span-1"
        />
        <Widget.CreditCustomerDetailsMaritalStatus {...PROPS.maritalStatus} />
        <Widget.CreditCustomerDetailsNumberOfDependants
          {...PROPS.numberOfDependents}
        />
      </div>
    </>
  );
};

export default PersonalInformationFields;
